import React from "react";
import { inputProps, labelProps, containerProps } from "../type";

//labels
export const Label: React.FC<labelProps> = ({ htmlFor, title }) => {
  return (
    <label
      htmlFor={htmlFor}
      style={{
        color: "#808080",
        fontSize: "1rem",
        fontWeight: "bold",
      }}
    >
      {title}
    </label>
  );
};

//container for the fields
export const Container: React.FC<containerProps> = ({ children }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "5px",
        width: "100%",
      }}
    >
      {children}
    </div>
  );
};
//inputs
export const Inputs: React.FC<inputProps> = ({
  id,
  type,
  placeholder,
  value,
  name,
  onChange,
  icon,
  readonly,
  required,
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "5px",
        border: "1px solid #E1E8ED",
        borderRadius: "10px",
        padding: "0px 10px",
      }}
    >
      <style>
        {`
          .input {
            width: 100%;
            border:none;
            border-radius: 5px;
            padding: 10px;
            font-size: 1rem;
            font-weight: bold;
            color: #333; 
            outline: none; 
          }
          .input::placeholder {
            color: #a0a0a0; 
            font-size:14px
         
          }
          .input:focus {
            border-color: #404040; /* Darker border on focus for feedback */
          }

          .icons{
            cursor: pointer;
          }
        `}
      </style>
      <input
        id={id}
        type={type}
        name={name}
        placeholder={placeholder}
        className="input"
        value={value}
        onChange={onChange}
        required={required}
        readOnly={readonly}
      />
      {icon && <div className="icons">{icon}</div>}
    </div>
  );
};
